<script>
export default {
  props: {
    show: Boolean,
  },
};
</script>

<template>
  <Transition name="modal">
    <div v-if="show" class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <div style="border: 2px solid #029E42; padding: 10px;">
              <img
            src="../assets/logo-azul_v2.png"
            class="bi me-2"
             style="width: 100%; height: 100%; object-fit: contain;"
            role="img"
            aria-label="RestoLine"
          />
            </div>
          </div>
          <div class="modal-body">
            <slot name="body"></slot>
          </div>

          <div class="modal-footer">
  <label >
    <input style="margin-right: 20px;" type="checkbox" v-model="noVolverAMostrar" />
    No volver a mostrar
  </label>

  <button style="color: blue; background: none; border: none; padding: 0; margin-left: auto;"  @click="handleClose">
    Cerrar
  </button>
</div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  props: {
    show: Boolean,
  },
  data() {
    return {
      noVolverAMostrar: false, // Estado del checkbox
    };
  },
  methods: {
    handleClose() {
      // Emitir el evento con el valor del checkbox
      this.$emit('confirmar', this.noVolverAMostrar);
    },
  },
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.modal-container {
  width: 80%;
  max-width: 500px;
  margin: 20px;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  max-height: 80vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}

.modal-logo {
  width: 100%;
  max-width: 200px;
  height: auto;
}

.modal-body {
  text-align: center;
  margin-bottom: 20px;
}

.modal-footer {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.btn-block {
  width: 100%;
}

.modal-enter-active,
.modal-leave-active {
  opacity: 1;
  transition: opacity 0.3s;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-active .modal-container,
.modal-leave-active .modal-container {
  transform: scale(1);
  transition: transform 0.3s;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  transform: scale(1.1);
}
</style>
